module.exports = __webpack_public_path__ + "static/media/materialui.0555e66c.png";